<div id="page_content">
  <div id="page_content_inner">
    <div>This is an empty page</div>
  </div>
</div>
